// extracted by mini-css-extract-plugin
export default {"text":"CompanyManageNumberEditPopup_text__hLpl8","field":"CompanyManageNumberEditPopup_field__aiE0k"};